import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskQueuesIssueRoute: InvariantJiraRoute = {
	name: 'servicedesk-queues-issue',
	path: '/jira/servicedesk/projects/:projectKey/queues/issue/:issueKey',
	exact: true,
};
